import * as Actions from "../actions/actions";

export function shouldEnableInputBox(settings, store) //TODO: Align with other locking refactor
{
    let windowBaseLoc = settings.stateLocations.Window.Base;

    if(settings.stateLocations.Window.InputBoxLocked)
    {
        let inputBoxLockedLocation = settings.stateLocations.Window.InputBoxLocked.Base;
        let enableAfterLinkLoc = settings.stateLocations.Window.InputBoxLocked.ReenableOnLinkClick;

        if(windowBaseLoc && inputBoxLockedLocation && enableAfterLinkLoc)
        {
            return store.getState()[windowBaseLoc][inputBoxLockedLocation][enableAfterLinkLoc] || false;
        }
    }

    return false;
}

export function enableInputBox(shouldEnable, settings, store) //TODO: Align with other locking refactor
{
    if(!shouldEnable)
    {
        return;
    }

    let inputboxLockedBase = settings.stateLocations.Window.InputBoxLocked.Base;
    let isLockedLoc = settings.stateLocations.Window.InputBoxLocked.isInputBoxLocked;

    let payload =
    {
        inputboxDisabled: false,
        stateLocation: `${inputboxLockedBase}.${isLockedLoc}`
    };

    store.dispatch(Actions.alterInputBoxDisabledStatus(payload));
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-display-links/src/inputBoxLocking/index.js